import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import ModalWrapper from 'components/Modals/ModalWrapper';

class ReassignWhsDocumentModal extends Component {
  static propTypes = {
    isShown: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    formId: PropTypes.number.isRequired,
    originalFileName: PropTypes.string,
    boDbIdToName: PropTypes.objectOf(PropTypes.string)
  };

  static defaultProps = {
    originalFileName: '',
    boDbIdToName: {}
  };

  constructor() {
    super();
    this.state = { disableConfirmButton: true, modalSize: 'modal-allow-overflow', currentlySelectedBoId: '' };
    this.setDisableConfirm = this.setDisableConfirm.bind(this);
    this.disableConfirm = this.disableConfirm.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isShown } = this.props;
    if (!prevProps.isShown && isShown) {
      this.setState({
        currentlySelectedBoId: '',
        disableConfirmButton: true
      });
    }
  }

  onCloseModal(e) {
    const { onCancel } = this.props;

    if (onCancel) {
      onCancel(e);
    }
  }

  setDisableConfirm(val) {
    const { disableConfirmButton } = this.state;
    if (disableConfirmButton !== val) {
      this.setState({ disableConfirmButton: val });
    }
  }

  handleFormTypeChange = (e) => {
    const currentlySelectedBoId = e.target.value;
    this.setState({ currentlySelectedBoId });

    this.setDisableConfirm(currentlySelectedBoId === '');
  };

  disableConfirm() {
    if (this.state) {
      const { disableConfirmButton } = this.state;
      return disableConfirmButton;
    }
    return true;
  }

  submitNewBoId(e, formId, newBoId) {
    this.setDisableConfirm(true);
    e.preventDefault();

    const { onSubmit } = this.props;
    onSubmit(formId, newBoId);
  }

  render() {
    const {
      isShown,
      formId,
      originalFileName,
      boDbIdToName
    } = this.props;
    const {
      modalSize,
      disableConfirmButton
    } = this.state;
    const { currentlySelectedBoId: selectedBoId } = this.state;
    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title={ `Reassign Form - ${ originalFileName }` }
        btnConfirmTitle="Submit"
        btnConfirmClass="btn-primary"
        btnCancelTitle="Close"
        onCancel={ e => this.onCloseModal(e) }
        disableConfirm={ () => disableConfirmButton }
        modalSize={ modalSize }
        formId="reassignForm"
        useDummySubmit
      >
        <div className="reassign-whs-document-modal">
          <div className="form-group mt-2">
            <div className="col-4">
              <label
                htmlFor="select-new-beneficial-owner"
                className="form-label m-2 text-left"
              >
                Assign to:
              </label>
            </div>
            <div className="col-8">
              <select
                id="select-new-beneficial-owner"
                name="new-beneficial-owner"
                className="form-input"
                value={ selectedBoId }
                onChange={ this.handleFormTypeChange }
              >
                <option value="" disabled>Select a customer</option>
                {
                    Object.entries(boDbIdToName).map(([id, description]) => (
                      <option key={ id } value={ id }>{description}</option>
                    ))
                }
              </select>
            </div>
          </div>
        </div>
        <button
          type="button"
          id="dummy-add-form-btn"
          className="hide"
          onClick={ e => this.submitNewBoId(e, formId, selectedBoId) }
        >Submit</button>
      </ModalWrapper>
    );
  }
}

export default ReassignWhsDocumentModal;
